export default class GenericUtils {
    static convertQueryParamsToObject = (url: string) => {
        const queryParams = url?.split("?")[1];
        if (!queryParams) {
            return {};
        }

        const queryParamsArray = queryParams?.split("&");
        const queryParamsObject = {} as any;

        queryParamsArray.forEach(param => {
            const [key, value] = param.split("=");
            queryParamsObject[key] = value;
        });

        return queryParamsObject;
    };

    static identifyUrlOrProtocol = (input: string): string => {
        if (/^(https?:\/\/|http:\/\/|ftp:\/\/)/i.test(input)) {
            return "URL";
        }

        if (/^(eitri:)/i.test(input)) {
            return "PROTOCOL";
        }

        return "unknown";
    };

    static formatCredentialDate = (dateStr: string): string => {
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) {
            return "invalid_date";
        }

        const abbreviatedMonths = [
            "jan.",
            "fev.",
            "mar.",
            "abr.",
            "mai.",
            "jun.",
            "jul.",
            "ago.",
            "set.",
            "out.",
            "nov.",
            "dez."
        ];

        const day = String(date.getDate()).padStart(2, "0");
        const month = abbreviatedMonths[date.getMonth()];
        const year = date.getFullYear();
        const hour = String(date.getHours()).padStart(2, "0");
        const minute = String(date.getMinutes()).padStart(2, "0");
        const second = String(date.getSeconds()).padStart(2, "0");

        return `Conectado em ${day} de ${month} de ${year}, ${hour}:${minute}:${second}`;
    };
}
